import clsx from 'clsx';
import {
  FiFtnLogo,
  DkMitIdLogo,
  NoBankIdLogo,
  SeBankIdLogo,
  BeItsMeLogo,
  FrejaLogo,
  NlIdinLogo,
  SmartIdLogo,
  EeEstEidLogo,
  EeEsteIdMobile,
  BeBeId,
  DeNpaLogo,
  ZealIdLogo,
  EvrotrustLogo,
  DTrustSignMe,
  SimplySign,
} from '@app/components/modals/sign-contract/electronic-id-options/logos';
import style from './electronic-id.module.scss';

const logoMap: Record<
  string,
  {
    component: React.ComponentType<{
      className?: string;
    }>;
    className: string;
  }
> = {
  eidHubSeBankidSign: {
    component: SeBankIdLogo,
    className: style.LogoSquare,
  },
  seBankid: {
    component: SeBankIdLogo,
    className: style.LogoSquare,
  },
  eidHubNoBankidSign: {
    component: NoBankIdLogo,
    className: style.Logo,
  },
  noBankid: {
    component: NoBankIdLogo,
    className: style.Logo,
  },
  eidHubDkMitidSign: {
    component: DkMitIdLogo,
    className: style.Logo,
  },
  dkNemid: {
    component: DkMitIdLogo,
    className: style.Logo,
  },
  eidHubFiFtnSign: {
    component: FiFtnLogo,
    className: style.Logo,
  },
  fiFtn: {
    component: FiFtnLogo,
    className: style.Logo,
  },
  eidHubBeItsmeSign: {
    component: BeItsMeLogo,
    className: style.LogoSquare,
  },
  eidHubFrejaSign: {
    component: FrejaLogo,
    className: style.Logo,
  },
  eidHubNlIdinSign: {
    component: NlIdinLogo,
    className: style.LogoSquare,
  },
  eidHubSmartidSign: {
    component: SmartIdLogo,
    className: style.LogoSquare,
  },
  eidHubEeEsteidSign: {
    component: EeEstEidLogo,
    className: style.LogoSquare,
  },
  eidHubEeEsteidMobileSign: {
    component: EeEsteIdMobile,
    className: style.LogoSquare,
  },
  eidHubBeBeidSign: {
    component: BeBeId,
    className: style.LogoSquare,
  },
  eidHubDeNpaSign: {
    component: DeNpaLogo,
    className: style.LogoSquare,
  },
  eidHubZealidSign: {
    component: ZealIdLogo,
    className: style.Logo,
  },
  eidHubEvrotrustSign: {
    component: EvrotrustLogo,
    className: style.Logo,
  },
  eidHubDTrustSignMeSign: {
    component: DTrustSignMe,
    className: style.Logo,
  },
  eidHubSimplySignSign: {
    component: SimplySign,
    className: style.Logo,
  },
};

type ElectronicIdLogoProps = {
  logoKey: keyof typeof logoMap;
};

/* eslint-disable react/prop-types */
export const ElectronicIdLogo: React.FC<ElectronicIdLogoProps> = ({ logoKey }) => {
  const LogoComponent = logoMap[logoKey]?.component;
  const logoClassName = logoMap[logoKey]?.className;

  if (!LogoComponent) {
    return null;
  }

  return <LogoComponent className={clsx(logoClassName)} />;
};
